class TeamStoreLockForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.input = this.querySelector('input[name="team_store_passcode"]');
    this.error = this.querySelector('.team-store-lock-form__error');
    this.submitButton = this.querySelector('[type="submit"]');

    if (!this.form) return;

    this.onSubmit = this.onSubmit.bind(this);
    this.form.addEventListener('submit', this.onSubmit);
    this.maybeShowPendingError();
  }

  disconnectedCallback() {
    if (this.form) this.form.removeEventListener('submit', this.onSubmit);
  }

  maybeShowPendingError() {
    const pendingId = sessionStorage.getItem('team-store-unlock');
    const collectionId = this.dataset.collectionId;
    if (!pendingId || !collectionId || pendingId !== collectionId) return;

    sessionStorage.removeItem('team-store-unlock');
    this.showError();
  }

  showError() {
    if (!this.error) return;
    this.error.hidden = false;
    this.input?.focus();
  }

  async onSubmit(event) {
    event.preventDefault();
    if (!this.input) return;

    const passcode = this.input.value.trim();
    const collectionId = this.dataset.collectionId;
    if (!passcode || !collectionId) return;

    const updateUrl = window.routes?.cart_update_url;
    if (!updateUrl) return;

    this.submitButton?.setAttribute('aria-busy', 'true');
    this.submitButton?.setAttribute('disabled', 'disabled');
    if (this.error) this.error.hidden = true;

    sessionStorage.setItem('team-store-unlock', collectionId);

    try {
      const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) throw new Error('Cart fetch failed');
      const cart = await cartResponse.json();
      const attributes = Object.assign({}, cart.attributes || {});
      attributes[`team_unlock_${collectionId}`] = passcode;

      const response = await fetch(updateUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes }),
      });

      if (!response.ok) throw new Error('Cart update failed');

      window.location.assign(this.dataset.redirect || window.location.href);
    } catch (error) {
      sessionStorage.removeItem('team-store-unlock');
      this.showError();
      this.submitButton?.removeAttribute('aria-busy');
      this.submitButton?.removeAttribute('disabled');
    }
  }
}

if (!customElements.get('team-store-lock-form')) {
  customElements.define('team-store-lock-form', TeamStoreLockForm);
}

function openTeamStoreLockDialog(trigger) {
  const dialog = document.getElementById('TeamStoreLockDialog');
  if (!dialog) return;

  const form = dialog.querySelector('team-store-lock-form');
  const title = dialog.querySelector('[data-team-store-lock-title]');
  const input = dialog.querySelector('input[name="team_store_passcode"]');
  const error = dialog.querySelector('.team-store-lock-form__error');

  if (form) {
    form.dataset.collectionId = trigger.dataset.collectionId || '';
    form.dataset.redirect = trigger.dataset.redirect || '';
  }
  if (title) title.textContent = trigger.dataset.collectionTitle || '';
  if (error) error.hidden = true;
  if (input) input.value = '';

  if (typeof dialog.showModal === 'function') {
    dialog.showModal();
  } else {
    dialog.setAttribute('open', '');
  }

  input?.focus();
}

function closeTeamStoreLockDialog() {
  const dialog = document.getElementById('TeamStoreLockDialog');
  if (!dialog) return;
  if (typeof dialog.close === 'function') {
    dialog.close();
  } else {
    dialog.removeAttribute('open');
  }
}

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-team-store-lock-open]');
  if (trigger) {
    event.preventDefault();
    openTeamStoreLockDialog(trigger);
    return;
  }

  if (event.target.closest('[data-team-store-lock-close]')) {
    closeTeamStoreLockDialog();
  }
});

document.addEventListener('click', (event) => {
  const dialog = document.getElementById('TeamStoreLockDialog');
  if (event.target === dialog) closeTeamStoreLockDialog();
});
